import { z } from 'zod';

export const dcDocumentHeadersSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  deleted: z.boolean(),
  isFromManager: z.boolean(),
  companyId: z.string(),
  representativeCustomerCode: z.string().optional(),
  representativeCustomerName: z.string().optional(),
  customerSiteCode: z.string().optional(),
  customerSiteName: z.string().optional(),
  representativeRecipientCode: z.string().optional(),
  representativeRecipientName: z.string().optional(),
  recipientSiteCode: z.string().optional(),
  recipientSiteName: z.string().optional(),
  documentNumber: z.string().optional(),
  isInvalid: z.boolean(),
  officialDate: z.string().optional(),
  exported: z.boolean(),
});

export const getDCDocumentHeadersWithConditionsSchema = z.array(dcDocumentHeadersSchema);

export type GetDCDocumentHeadersWithConditionsResponse = z.infer<
  typeof getDCDocumentHeadersWithConditionsSchema
>;
